import { render, staticRenderFns } from "./DashboardNationalPresident.vue?vue&type=template&id=d22d430c"
import script from "./DashboardNationalPresident.vue?vue&type=script&lang=js"
export * from "./DashboardNationalPresident.vue?vue&type=script&lang=js"
import style0 from "./DashboardNationalPresident.vue?vue&type=style&index=0&id=d22d430c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports